
export class Lookup<T> {

  private _length: number = 0;
  private _keyExtractor: (item: T) => string | number;
  private _lu: any = {};

  public get length(): number {
    return this._length;
  }

  private key(item: T): string {

    if (typeof item == "undefined" || item == null) return "undefined:null";

    let val: string | number = this._keyExtractor(item);
    return (typeof val) + ":" + val;
  }

  public set source(items: T[]) {
    this._lu = {};

    if (items) {
      this.add(...items);
      this._length = items.length;
    }
  }

  public get source(): T[] {
    let src: T[] = [];

    for (let o in this._lu) src.push(this._lu[o]);
    return src;
  }

  public get(key: string | number, def?: T): T {
    key = typeof key == 'undefined' || key == null ? 'undefined:null' : (typeof key) + ":" + key;
    return typeof this._lu[key] !== 'undefined' ? this._lu[key] : def;
  }

  public has(key: string | number): boolean {
    key = typeof key == 'undefined' || key == null ? 'undefined:null' : (typeof key) + ":" + key;
    return typeof this._lu[key] !== 'undefined';
  }
  
  public add(...items: T[]) {
    items.forEach(i => {
      let key: string = this.key(i);
      this._lu[key] = i;
    });    
  }

  public remove(...items: T[]) {
    items.forEach(i => {
      let key: string = this.key(i);
      if (typeof this._lu[key] !== 'undefined') delete this._lu[key];
    })
  }

  constructor(keyExtractor: (item: T) => string | number, ...source:T[]) {
    this._keyExtractor = keyExtractor;
    this.source = source;
  }
}
